// extracted by mini-css-extract-plugin
module.exports = {"scrollFix":"callOut-module--scroll-fix--j9N1F","center":"callOut-module--center--1sNM7","message":"callOut-module--message--Ufe3w"};